/**
 * Componente que muestra un estado vacío motivador en el Dashboard para nuevos usuarios.
 * Invita a crear la primera lista o usar el escáner de salud.
 */
import React from "react";
import { Box, Typography, Button, Stack, Card, CardContent } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function DashboardEmptyState() {
    const navigate = useNavigate();

    return (
        <Box sx={{ textAlign: "center", py: 6, px: 2 }}>
            <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <AutoAwesomeIcon sx={{ fontSize: 80, color: "primary.light", mb: 2, opacity: 0.5 }} />
                <Typography variant="h5" sx={{ fontWeight: 900, mb: 1 }}>
                    ¡Tu viaje de ahorro comienza aquí! 🚀
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400, mx: "auto" }}>
                    Aún no tienes listas ni actividad. Empieza por crear tu primera lista o escanea un producto para ver si es saludable.
                </Typography>

                <Stack spacing={2} direction={{ xs: "column", sm: "row" }} justifyContent="center">
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<AddIcon />}
                        onClick={() => navigate("/listas")}
                        sx={{ borderRadius: 3, fontWeight: 700, px: 4, textTransform: "none" }}
                    >
                        Crear mi primera lista
                    </Button>
                    <Button
                        variant="outlined"
                        size="large"
                        startIcon={<CameraAltIcon />}
                        onClick={() => navigate("/scan")}
                        sx={{ borderRadius: 3, fontWeight: 700, px: 4, textTransform: "none" }}
                    >
                        Probar el Escáner
                    </Button>
                </Stack>
            </motion.div>
        </Box>
    );
}
